export const selectLingoLiftTeacherDashboardParamsFromDomObject = (object: HTMLElement) => {
  const teacherName = object.dataset.teacherName!;
  const isListenwise = (object.dataset.isListenwise === 'true') as boolean;
  const isLingolift = (object.dataset.isLingolift === 'true') as boolean;
  const manageClassesUrl = object.dataset.manageClassesUrl!;
  return {
    teacherName,
    isListenwise,
    isLingolift,
    manageClassesUrl,
  };
};
